import module from '../module';
import * as _ from 'lodash';
import {IdleDetectingService} from "./IdleDetectingService";

function ConfigurationService($http, $q, cartonomyConfig) {

    const urlBase = cartonomyConfig.ApiV2 + 'retailer/default' + window.location.search;

    let configurationService = {};

    const promise = $http.get(urlBase).then((response) => {
        configurationService.retailer = response.data;
        return configurationService.retailer;
    });

    configurationService.getRetailer = () => _.cloneDeep(configurationService.retailer);

    configurationService.getRetailerSettings = () => {
        return $http.get(cartonomyConfig.ApiV2 + 'retailer/settings')
            .then((settingsResponse) => {
                return settingsResponse.data;
            });
    };

    configurationService.getItem = (key) => {

        // todo: temporary solution to not to store hardcoded and potentially configurable values
        switch (key) {
            case 'deliveryDaysRange':
                return $q.resolve(5);
        }

        return promise.then((data) => {
            return _.cloneDeep(data[key]);
        });
    };

    return configurationService;
}

module.factory('ConfigurationService', ['$http', '$q', 'cartonomyConfig', ConfigurationService]);



// WEBPACK FOOTER //
// ./src/modules/shared/services/ConfigurationService.js